import ResponsiveImage from '~/components/Image/ResponsiveImage'
import useAvatarImageUrl from '~/dashboard/hooks/useAvatarImageUrl'

export default function AvatarImage(): React.ReactElement {
  const avatarImageObject = useAvatarImageUrl()

  if (avatarImageObject.isDeprecatedUrl || !avatarImageObject.isExists || avatarImageObject.isUnder13) {
    return (
      <ResponsiveImage
        fit="contain"
        height={60}
        imageClassName="min-w-12 min-h-12 -ml-1.5 -mt-0.5"
        imageWidths="100"
        srcKey={avatarImageObject.url}
        width={60}
      />
    )
  }

  return (
    <ResponsiveImage
      fit="contain"
      height={60}
      imageClassName="min-w-20 min-h-20 -ml-5 -mt-1.5"
      imageWidths="100"
      src={avatarImageObject.url}
      width={60}
    />
  )
}
